export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">
            有好的韩漫资源推荐或合作意向？欢迎通过下方表单与我们取得联系
          </p>

          <form
            data-readdy-form
            action="https://readdy.ai/api/form/d9ku5i6c26n1c7c5qn3g"
            method="POST"
            encType="application/x-www-form-urlencoded"
            className="bg-background-50 rounded-lg p-6 md:p-8 space-y-5"
          >
            <div className="honeypot-field">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  姓名
                </label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  邮箱
                </label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
            </div>

            <div>
              <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                主题
              </label>
              <select
                id="contact-subject"
                name="subject"
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md text-foreground-800 focus:outline-none focus:border-primary-400 transition-colors appearance-none cursor-pointer"
              >
                <option value="">请选择主题</option>
                <option value="recommend">韩漫资源推荐</option>
                <option value="cooperation">商务合作</option>
                <option value="feedback">意见反馈</option>
                <option value="other">其他</option>
              </select>
            </div>

            <div>
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言内容
              </label>
              <textarea
                id="contact-message"
                name="message"
                rows={4}
                maxLength={500}
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                placeholder="请输入留言内容（最多500字）"
              ></textarea>
              <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
            </div>

            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              提交留言
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}